module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-grid-single-5a89725b7cfecf4c65e2d3069d27afab.png";